import React, {
  useCallback,
  useMemo,
  useRef,
  useEffect,
  useState,
} from "react";
import * as Global from "../styles/Global";
import {
  ContentSection,
  FlexColumn,
  TextOnlyButton,
  FlexRow,
  LargeButton,
  LargeButtonSecondary,
  ButtonText,
  SlideUpModal,
  ModalOverlay,
  FormInputField,
  Text,
} from "../styles/Global";
import moment from "moment";
import Stack from "@mui/material/Stack";
import Skeleton from "@mui/material/Skeleton";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputAdornment from "@mui/material/InputAdornment";
import OutlinedInput from "@mui/material/OutlinedInput";
import loading from "react-useanimations/lib/loading";
import UseAnimations from "react-useanimations";
import { RowGroupingModule } from "@ag-grid-enterprise/row-grouping";
import { MenuModule } from "@ag-grid-enterprise/menu";
import { SetFilterModule } from "@ag-grid-enterprise/set-filter";
import { BiLogInCircle, BiRefresh } from "react-icons/bi";
import { IoIosArrowDropupCircle } from "react-icons/io";
import { IoMdRemoveCircleOutline } from "react-icons/io";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { BsFilterRight } from "react-icons/bs";
import { toast } from "react-toastify";
import {
  DateTimePicker,
  LocalizationProvider,
  DatePicker,
} from "@mui/x-date-pickers";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Switch } from "@mui/material";

import Autocomplete from "react-google-autocomplete";
import { useSelector } from "react-redux";
import QuickToggle from "./QuickToggle";
import { GeocodeLatLng } from "../functions/helperFunctions";
import { useDebounce, useDebouncedCallback } from "use-debounce";
import { ArrowCircleRight } from "@mui/icons-material";

function FindTournamentFilterOptions({
  openFilter,
  getRowData,
  setOpenFilter,
  state,
  dispatch,
  sport,
  tableValue,
  geocodeError,
  isClubProfile
}) {
  const placesRef = useRef(null);
  const localFilter =
    JSON.parse(localStorage.getItem("findTournamentFilters")) || {};
  const localOrganizer = JSON.parse(localStorage.getItem("organizer")) || {};
  const localStoragePlayer = JSON.parse(localStorage.getItem("player"));
  const darkMode = localStorage.getItem("global")
    ? JSON.parse(localStorage.getItem("global")).darkMode
    : false;
  const [customLocation, setCustomLocation] = useState(state.customDistance);
  const player = useSelector((state) => state.player);
  const params = new URLSearchParams(window.location.search);
  const location = params.get("location");
  const organizerAccount = useSelector((state) => state.accountID);
  console.log("geocodeError: ", geocodeError);
  const userID = params.get("user")
    ? params.get("user")
    : player && player.userID
    ? player.userID
    : localStoragePlayer && localStoragePlayer.hasOwnProperty("userID")
    ? localStoragePlayer.userID
    : null;
  console.log("findtournamentfilteroptions player: ", player);
  console.log(
    "findtournamentfilteroptions params.get(user): ",
    params.get("user")
  );
  console.log(
    "findtournamentfilteroptions localStoragePlayer: ",
    localStoragePlayer
  );
  console.log("findtournamentfilteroptions userID: ", userID);
  const accountID =
    localFilter && localFilter.hasOwnProperty("accountid")
      ? localFilter.accountid
      : localOrganizer.accountid
      ? localOrganizer.accountid
      : null;
  const debounced = useDebouncedCallback(
    // function
    (value, type) => {
      if (type === "customDistance") {
        dispatch({
          type: "custom_distance",
          customDistance: value,
        });
      }
    },
    // delay in ms
    1000
  );

  function NoUser(type) {
    if (type === "mine") {
      dispatch({ type: "mine_player", minePlayer: false });
      toast.error(
        "Log in to your player profile to filter your player tournaments",
        {
          autoClose: 5000,
        }
      );
    } else {
      dispatch({ type: "favorites", favorites: false });
      toast.error("Log in to your player profile to filter your favorites", {
        autoClose: 5000,
      });
    }
  }

  useEffect(() => {
    if (
      state.showCustomDistance &&
      localFilter.customDistance !== state.customDistance
    ) {
      console.log("state.showCustomDistance useEffect: ", state);
      console.log("state.showCustomDistance localFilter: ", localFilter);
      setCustomLocation(state.customDistance);
      GeocodeLatLng(state, localFilter.customDistance, dispatch);
    }
  }, [state.showCustomDistance]);

  console.log("customLocation: ", customLocation);
  console.log("Tournament filter options organizer: ", accountID);
  return (
    <>
      {tableValue === 2 ? (
        <FlexColumn align="center" justify="center" style={{ width: "100%" }}>
          <FlexRow align="center" style={{ marginTop: 5, width: "100%" }}>
            <button
              style={{
                display: "flex",
                flex: 1,
                justifyContent: "center",
                padding: "9px 10px",
                border: `1px solid ${
                  state.minePlayer ? Global.red : Global.blueLight
                }`,
                borderRadius: 20,
                backgroundColor: state.minePlayer
                  ? "#CC0C0D35"
                  : darkMode
                  ? "transparent"
                  : "#fff",
              }}
              onClick={() => {
                userID && params.get("pin") && params.get("pin") !== ""
                  ? dispatch({
                      type: "mine_player",
                      minePlayer: !state.minePlayer,
                    })
                  : NoUser("mine");
              }}
            >
              <Text
                style={{
                  fontWeight: "600",
                  fontSize: ".8em",
                  textTransform: "uppercase",
                  color: state.minePlayer ? Global.red : Global.blueLight,
                }}
              >
                PLAYER
              </Text>
            </button>
            {accountID && (
              <button
                style={{
                  display: "flex",
                  flex: 1,
                  justifyContent: "center",
                  padding: "9px 10px",
                  marginLeft: 10,
                  border: `1px solid ${
                    state.mineOrganizer ? Global.red : Global.blueLight
                  }`,
                  borderRadius: 20,
                  backgroundColor: state.mineOrganizer
                    ? "#CC0C0D35"
                    : darkMode
                    ? "transparent"
                    : "#fff",
                }}
                onClick={() =>
                  accountID && accountID !== ""
                    ? dispatch({
                        type: "mine_organizer",
                        mineOrganizer: !state.mineOrganizer,
                      })
                    : dispatch({ type: "mine_organizer", mineOrganizer: false })
                }
              >
                <Text
                  style={{
                    fontWeight: "600",
                    fontSize: ".8em",
                    color: state.mineOrganizer ? Global.red : Global.blueLight,
                    textTransform: "uppercase",
                  }}
                >
                  ORGANIZER
                </Text>
              </button>
            )}
            <button
              style={{
                display: "flex",
                flex: 1,
                justifyContent: "center",
                padding: "9px 10px",
                marginLeft: 10,
                border: `1px solid ${
                  state.favorites ? Global.red : Global.blueLight
                }`,
                borderRadius: 20,
                backgroundColor: state.favorites
                  ? "#CC0C0D35"
                  : darkMode
                  ? "transparent"
                  : "#fff",
              }}
              onClick={() => {
                userID && params.get("pin") && params.get("pin") !== ""
                  ? dispatch({ type: "favorites", favorites: !state.favorites })
                  : NoUser("favorite");
              }}
            >
              <Text
                style={{
                  fontWeight: "600",
                  fontSize: ".8em",
                  textTransform: "uppercase",
                  color: state.favorites ? Global.red : Global.blueLight,
                }}
              >
                FAVORITES
              </Text>
            </button>
          </FlexRow>

          <QuickToggle
            style={{ width: "100%", marginTop: 10 }}
            option1="Upcoming"
            option2="Past"
            selected={state.mineUpcoming}
            setSelected={() => {
              if (state.mineUpcoming) {
                dispatch({
                  type: "date_start",
                  dateStart: new Date().toISOString(),
                });
                dispatch({
                  type: "date_end",
                  dateEnd: new Date(
                    new Date(state.dateEnd).setFullYear(
                      new Date().getFullYear() + 6
                    )
                  ),
                });
              } else {
                dispatch({
                  type: "date_end",
                  dateEnd: new Date().toISOString(),
                });
                dispatch({
                  type: "date_start",
                  dateStart: new Date(
                    new Date(new Date().toISOString()).setFullYear(
                      new Date().getFullYear() - 5
                    )
                  ),
                });
              }
              dispatch({
                type: "mineUpcoming",
                mineUpcoming: !state.mineUpcoming,
              });
            }}
          />
        </FlexColumn>
      ) : (
        <>
          <FlexRow style={{ marginTop: 5 }}>
            <div className="inputField inputFieldSmall inputFieldDate">
              <ThemeProvider theme={Global.themeMode}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    renderInput={(props) => (
                      <FormInputField
                        id="outlined-basic-small"
                        label="Select Start Date"
                        variant="outlined"
                        fullWidth
                        size="small"
                        margin="dense"
                        {...props}
                      />
                    )}
                    label="Start Date"
                    size="small"
                    value={moment(state.dateStart).toDate()}
                    disablePast={tableValue === 0}
                    disableFuture={tableValue === 1}
                    onChange={(newValue) => {
                      dispatch({
                        type: "date_start",
                        //Do not set the date to greater than the end date
                        dateStart:
                          newValue > state.dateEnd ? state.dateStart : newValue,
                      });
                    }}
                  />
                </LocalizationProvider>
              </ThemeProvider>
            </div>
            <div
              className="inputField inputFieldSmall inputFieldDate"
              style={{ marginLeft: 5 }}
            >
              <ThemeProvider theme={Global.themeMode}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    renderInput={(props) => (
                      <FormInputField
                        id="outlined-basic-small"
                        label="Select End Date"
                        variant="outlined"
                        fullWidth
                        size="small"
                        margin="dense"
                        {...props}
                      />
                    )}
                    label="End Date"
                    size="small"
                    value={moment(state.dateEnd).toDate()}
                    disablePast={tableValue === 0}
                    disableFuture={tableValue === 1}
                    onChange={(newValue) => {
                      dispatch({
                        type: "date_end",
                        //Do not set the date to less than the start date
                        dateEnd:
                          newValue < state.dateStart ? state.dateEnd : newValue,
                      });
                    }}
                  />
                </LocalizationProvider>
              </ThemeProvider>
            </div>
          </FlexRow>
          <FlexRow
            style={{
              padding: "10px 0 0",
              width: "100%",
            }}
            align="center"
          >
            {((location !== "disabled" || state.showCustomDistance) && !isClubProfile) && (
              <FormControl
                fullWidth
                style={{
                  marginRight: 5,
                }}
              >
                <InputLabel id="distance-select">Distance</InputLabel>
                <Select
                  labelId="distance-select"
                  id="distance-select"
                  value={
                    state.distance
                      ? state.distance
                      : localFilter && localFilter.hasOwnProperty("distance")
                      ? localFilter.distance
                      : 10000
                  }
                  label="Distance"
                  onChange={(e) => {
                    console.log("event: ", e);
                    dispatch({
                      type: "distance",
                      distance: e.target.value,
                    });
                  }}
                >
                  <MenuItem value={2}>2mi</MenuItem>
                  <MenuItem value={5}>5mi</MenuItem>
                  <MenuItem value={10}>10mi</MenuItem>
                  <MenuItem value={25}>25mi</MenuItem>
                  <MenuItem value={50}>50mi</MenuItem>
                  <MenuItem value={75}>75mi</MenuItem>
                  <MenuItem value={100}>100mi</MenuItem>
                  <MenuItem value={200}>200mi</MenuItem>
                  <MenuItem value={300}>300mi</MenuItem>
                  <MenuItem value={10000}>All</MenuItem>
                </Select>
              </FormControl>
            )}

            {sport === "cornhole" && (
              <FormControl
                fullWidth
                style={{
                  marginRight: 5,
                }}
              >
                <InputLabel id="type-select">Type</InputLabel>
                <Select
                  labelId="type-select"
                  id="type-select"
                  value={state.generation || "All"}
                  label="Type"
                  onChange={(e) => {
                    console.log("event: ", e);
                    dispatch({
                      type: "generation",
                      generation: e.target.value,
                    });
                  }}
                >
                  <MenuItem value="All">All</MenuItem>
                  <MenuItem value="Blind Draw">Blind Draw</MenuItem>
                  <MenuItem value="Switcholio">Switcholio</MenuItem>
                  <MenuItem value="Split Switch">Split Switch</MenuItem>
                  <MenuItem value="Set Teams">Set Teams</MenuItem>
                  <MenuItem value="Singles">Singles</MenuItem>
                  <MenuItem value="Squadholio">Squadholio</MenuItem>
                </Select>
              </FormControl>
            )}
          </FlexRow>
          {(location === "disabled" || (state.lat === 0 && state.lng === 0)) &&
            !state.showCustomDistance && (
              <FlexRow
                style={{ width: "100%", marginTop: 10 }}
                align="center"
                justify="center"
              >
                <Text
                  style={{ fontStyle: "italic", textAlign: "center" }}
                  color="red"
                  size=".9em"
                >
                  Location Services Disabled
                </Text>
              </FlexRow>
            )}
          <FlexRow
            justify="space-between"
            align="center"
            style={{ paddingLeft: 5, width: "100%" }}
          >
            <Text
              size="1em"
              style={
                {
                  // textTransform: "uppercase",
                }
              }
            >
              GPS Location
            </Text>
            <QuickToggle
              style={{ width: "60%", marginTop: 10 }}
              option1="Automatic"
              option2="Manual"
              selected={state.showCustomDistance}
              setSelected={() => {
                dispatch({
                  type: "show_custom_distance",
                  showCustomDistance: !state.showCustomDistance,
                });
              }}
            />
          </FlexRow>
          {state.showCustomDistance && (
            <>
              <FlexRow align="center" style={{ width: "100%" }}>
                <div
                  className="inputField inputFieldSmall"
                  style={{ width: "100%" }}
                >
                  <FormInputField
                    className="selectInputSmall selectNoBorderRight"
                    id="outlined-basic-small"
                    label="Zip/Address"
                    variant="outlined"
                    fullWidth
                    size="small"
                    margin="dense"
                    onChange={(e) => setCustomLocation(e.target.value)}
                    defaultValue={
                      state.showCustomDistance && state.customDistance
                        ? state.customDistance
                        : ""
                    }
                  />
                </div>
                <LargeButtonSecondary
                  style={{
                    padding: "5px 5px 5px 10px",
                    marginTop: 3,
                    marginLeft: 3,
                  }}
                  onClick={() => GeocodeLatLng(state, customLocation, dispatch)}
                >
                  <ButtonText style={{ fontSize: ".8em" }} secondary>
                    SET
                  </ButtonText>
                  <BiLogInCircle
                    color={Global.red}
                    size={18}
                    style={{ marginRight: 0, paddingRight: 0 }}
                  />
                </LargeButtonSecondary>
              </FlexRow>
              <Text
                style={{ paddingLeft: 5 }}
                size=".9em"
                color={
                  state.customAddress &&
                  !state.customAddress.includes("Incorrect")
                    ? Global.green
                    : Global.red
                }
              >
                {/* Selected Location: Los Angeles, CA, USA */}
                {state.customAddress &&
                !state.customAddress.includes("Incorrect")
                  ? "Selected Location:"
                  : null}{" "}
                {state.customAddress}
              </Text>
            </>
          )}
          <FlexRow
            justify="space-between"
            align="center"
            style={{
              paddingLeft: 5,
              width: "100%",
              marginTop: 10,
            }}
          >
            <FlexRow align="center">
              <Text size="1em">Sort By</Text>
              <QuickToggle
                style={{ width: "60%", marginLeft: 10 }}
                option1="Date"
                option2="Distance"
                selected={state.sort}
                setSelected={() =>
                  dispatch({
                    type: "sort",
                    sort: !state.sort,
                  })
                }
              />
            </FlexRow>
            <IoIosArrowDropupCircle
              onClick={() => setOpenFilter(false)}
              size={40}
              color={Global.red}
              style={{
                width: 50,
                // marginLeft: 10,
                cursor: "pointer",
              }}
            />
          </FlexRow>
        </>
      )}
    </>
  );
}

export default FindTournamentFilterOptions;
